import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import {
  LibraryDirectory,
  LibraryDirectoryCreateCommand,
  LibraryDirectoryEditCommand,
  LibraryType,
} from "../library.model";
import { DepartmentsService } from "../../departments/departments.service";
import { LibraryService } from "../library.service";
import { DatabaseService } from "../../shared/database.service";
import { MasterDataService } from "../../master-data/master-data-service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { UsersService } from "../../users/users.service";
import { MatSelectChange } from "@angular/material/select";

@Component({
    selector: "app-library-directory-edit",
    templateUrl: "./library-directory-edit.component.html",
    styleUrls: ["./library-directory-edit.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LibraryDirectoryEditComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private departmentsService = inject(DepartmentsService);
  private libraryService = inject(LibraryService);
  private databaseService = inject(DatabaseService);
  private masterDataService = inject(MasterDataService);
  usersService = inject(UsersService);
  private snackBar = inject(MatSnackBar);
  dialogRef = inject<MatDialogRef<LibraryDirectoryEditComponent>>(MatDialogRef);
  data = inject<LibraryDirectory>(MAT_DIALOG_DATA);

  form = this.formBuilder.group({
    uuid: new FormControl<string | null>(null),
    name: new FormControl<string | null>(null, [Validators.required]),
    parentUuid: new FormControl<string | null>(null),
    relatedObjectUuid: new FormControl<string | null>(null),
    externalId: new FormControl<string | null>(null),
  });

  editMode = false;
  directories$: Observable<LibraryDirectory[] | null>;

  LibraryT = LibraryType;

  constructor() {
    this.directories$ = this.libraryService.libraryDirectories$;
  }

  ngOnInit(): void {
    if (this.data.uuid != null) {
      this.editMode = true;
      this.patchValues();
    }
  }

  private patchValues() {
    this.form.patchValue({
      uuid: this.data.uuid,
      name: this.data.name,
      externalId: this.data.externalId,
      parentUuid: this.data.parent != null ? this.data.parent.uuid : null,
      relatedObjectUuid:
        this.data.relatedObjectUuid != null
          ? this.data.relatedObjectUuid
          : null,
    });
  }

  onCloseClick(): void {
    this.dialogRef.close(false);
  }

  onSave() {
    if (this.editMode) {
      const cmd: LibraryDirectoryEditCommand = {
        uuid: this.data.uuid,
        name: this.form.controls.name.value,
        parentUuid: this.form.controls.parentUuid.value,
        relatedObjectUuid: this.form.controls.relatedObjectUuid.value,
      };
      this.updateDirectoryToApi(cmd);
    } else {
      const cmd: LibraryDirectoryCreateCommand = {
        name: this.form.controls.name.value,
        parentUuid: this.form.controls.parentUuid.value,
        type: this.data.type,
        externalId: this.form.controls.externalId.value,
        relatedObjectUuid: this.form.controls.relatedObjectUuid.value,
      };

      this.saveDirectoryToApi(cmd);
    }
  }

  onPersonalFolderChange($event: MatSelectChange) {
    this.usersService.getUserData($event.value).subscribe({
      next: (usr) => this.form.controls.name.patchValue(usr.name),
      complete: () => console.log("COMPLTE"),
    });
  }

  saveDirectoryToApi(cmd: LibraryDirectoryCreateCommand) {
    let result = false;
    this.databaseService
      .addDirToLibrary(cmd)
      .pipe(
        finalize(() => {
          this.dialogRef.close(result);
        })
      )
      .subscribe({
        next: (response) => {
          if (response.status === 200 || response.status === 201) {
            result = true;
            this.snackBar.open("SUCCESS", "", {
              duration: 2000,
              panelClass: "app-snackbar-success",
            });
            console.log("Adding Directory Add save - response", response.body);
          } else {
            this.snackBar.open("ERROR", "", {
              duration: 2000,
              panelClass: "app-snackbar-alert",
            });
            console.error("Adding Directory Error by API");
          }
        },
        error: () => this.masterDataService.savingErrorMessage(),
      });
  }

  updateDirectoryToApi(cmd: LibraryDirectoryEditCommand) {
    let result = false;
    this.databaseService
      .updateDirInLibrary(cmd)
      .pipe(
        finalize(() => {
          this.dialogRef.close(result);
        })
      )
      .subscribe({
        next: (response) => {
          if (response.status === 200 || response.status === 201) {
            result = true;
            this.snackBar.open("SUCCESS", "", {
              duration: 2000,
              panelClass: "app-snackbar-success",
            });
            console.log("Directory Update save - response", response.body);
          } else {
            this.snackBar.open("ERROR", "", {
              duration: 2000,
              panelClass: "app-snackbar-alert",
            });
            console.error("Directory Update Error by API");
          }
        },
        error: () => this.masterDataService.savingErrorMessage(),
      });
  }
}
